import { IconWorld } from '@tabler/icons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { ButtonProps } from '@mantine/core'
import { useLang } from '@/hooks'
import useStyles from './AppLangPicker.styles'

interface IProps {
  className?: string
  btnProps?: ButtonProps
  white?: boolean
}

export const AppLangTextPicker: React.FC<IProps> = ({
  className,
  btnProps,
  white = false,
  ...props
}) => {
  const { changeLang } = useLang()
  const { i18n } = useTranslation()
  const { classes } = useStyles()

  const currentLang = i18n.language

  const onChange = async (code: string) => {
    await changeLang(code)
  }

  const handleClick = () => {
    if (currentLang === 'en') {
      onChange('pt')
    } else {
      onChange('en')
    }
  }

  return (
    <div className={white ? classes.container : classes.containerDark} onClick={handleClick}>
      <IconWorld />
      <span>
        <span
          style={{
            fontWeight: currentLang === 'en' ? 'bold' : 'normal',
          }}
        >
          EN
        </span>
        &nbsp;/&nbsp;
        <span
          style={{
            fontWeight: currentLang === 'pt' ? 'bold' : 'normal',
          }}
        >
          PT
        </span>
      </span>
    </div>
  )
}
